import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import AccordionTab from './Tab';
import { translate } from '../../../Services/translation';

const Accordion = ({}) => {
  const acc = useSelector((state) => state.productPage.accordians);
  const _accordions = acc
    .filter((a) => a.data != null && a.data.length > 0)
    .map((a) => ({ ...a, isOpen: false }));
  const [accordions, setAccordions] = useState(_accordions);

  const handleClick = (id) => {
    const newAccordions = accordions.map((a, i) => {
      const isOpen = !a.isOpen && id === i;
      return { ...a, isOpen };
    });
    setAccordions(newAccordions);
  };

  return (
    <>
      <h2>{translate('accordion.specification')}</h2>
      {accordions.map(({ type, title, data, isOpen }, k) => (
        <AccordionTab
          key={k}
          id={k}
          type={type}
          title={title}
          data={data}
          isOpen={isOpen}
          onClick={handleClick}
        />
      ))}
    </>
  );
};

export default Accordion;
